
import React, { useState, useEffect } from 'react';
import { Pagination, Card } from 'antd';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import apiClient from '../../Api/apiClient'; // Adjust the import path as needed
import { PHOTO_BASE_URL_Admin } from '../../Api/config';
import { FaEye, FaHeart } from 'react-icons/fa';
import TenderDescriptionDate from '../../Components/Dashboard/TenderDetails/TenderDescriptionDate';
import TenderDescriptionID from '../../Components/Dashboard/TenderDetails/TenderDescriptionID';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { BsFileEarmarkBreakFill } from 'react-icons/bs';
import tenderNotFoundImage from '../../Assets/images/tenderNotFoundImage.png';

dayjs.extend(customParseFormat);

const { Meta } = Card;

const AdvanceSearch = () => {
  const navigate = useNavigate();
  const [tenderData, setTenderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  // Filter states
  const [keyword, setKeyword] = useState('');
  const [tenderType, setTenderType] = useState('');
  const [sourceType, setSourceType] = useState('');
  const [tenderSection, setTenderSection] = useState('');
  const [tenderStatus, setTenderStatus] = useState('');
  const [district, setDistrict] = useState('');
  const [upazila, setUpazila] = useState('');
  // const [publishFromDate, setPublishFromDate] = useState(null);
  // const [publishToDate, setPublishToDate] = useState(null);
  // const [submissionFromDate, setSubmissionFromDate] = useState(null);
  // const [submissionToDate, setSubmissionToDate] = useState(null);

  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedDateType, setSelectedDateType] = useState('');
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);

  const [privateSection, setPrivateSection] = useState(false);
  const [govtSection, setGovtSection] = useState(false);
  const [internationalSection, setInternationalSection] = useState(false);

  const [tender_call_typeSection, setTender_call_typeSection] = useState(false);
  const [corrigendum_call_typeSection, setCorrigendum_call_typeSection] = useState(false);
  const [cancellation_call_typeSection, setCancellation_call_typeSection] = useState(false);

  const [ift, setIft] = useState(false);
  const [preq, setPreq] = useState(false);
  const [enlistment, setEnlistment] = useState(false);
  const [eoiFirm, setEoiFirm] = useState(false);
  const [eoiIndv, setEoiIndv] = useState(false);
  const [rfp, setRfp] = useState(false);
  const [aucSal, setAucSal] = useState(false);

  const [goodsTenderOn, setGoodsTenderOn] = useState(false);
  const [worksTenderOn, setWorksTenderOn] = useState(false);
  const [servicesTenderOn, setServicesTenderOn] = useState(false);

  const [newspaperSource, setNewspaperSource] = useState(false);
  const [eGpSource, setEGpSource] = useState(false);
  const [onlineSource, setOnlineSource] = useState(false);
  const [advertisementSource, setAdvertisementSource] = useState(false);
  const [websiteSource, setWebsiteSource] = useState(false);
  const [manualSource, setManualSource] = useState(false);





  console.log(selectedDateType)

  // Fetch data from backend
  useEffect(() => {
    const fetchTenders = async () => {
      const queryParams = new URLSearchParams({
        key: keyword,
        type: tenderType,
        source_type: sourceType,
        tender_section: tenderSection,
        // status: tenderStatus,
        district_name: district,
        upazila_name: upazila,


        // skip: currentPage,
        // limit: pageSize,
      });

      // Append selected date type and its from/to dates
      if (selectedDateType && fromDate && toDate) {
        queryParams.append(`${selectedDateType}_from_date`, fromDate.toISOString().split('T')[0]);
        queryParams.append(`${selectedDateType}_to_date`, toDate.toISOString().split('T')[0]);
      }


      if (privateSection) queryParams.append('tender_section', 'private');
      if (govtSection) queryParams.append('tender_section', 'govt');
      if (internationalSection) queryParams.append('tender_section', 'international');

      if (tender_call_typeSection) queryParams.append('tender_call_type', 'Tender');
      if (corrigendum_call_typeSection) queryParams.append('corrigendum_call_type', 'Corrigendum');
      if (cancellation_call_typeSection) queryParams.append('cancellation_call_type', 'Cancellation');

      // Append selected tender pattern values
      if (ift) queryParams.append('IFT_tender_pattern', 'IFT');
      if (preq) queryParams.append('Prep_tender_pattern', 'Preq');
      if (enlistment) queryParams.append('Enlistment_tender_pattern', 'Enlistment');
      if (eoiFirm) queryParams.append('EOI_Firm_tender_pattern', 'EOI(Firm)');
      if (eoiIndv) queryParams.append('EOI_Indi_tender_pattern', 'EOI(Indv)');
      if (rfp) queryParams.append('RFP_tender_pattern', 'RFP');
      if (aucSal) queryParams.append('Auc_sal_tender_pattern', 'Auc/Sal');

      // Append Goods, Works, and Services values
      if (goodsTenderOn) queryParams.append('goods_tender_on', 'good');
      if (worksTenderOn) queryParams.append('works_tender_on', 'worked');
      if (servicesTenderOn) queryParams.append('services_tender_on', 'services');


      if (newspaperSource) queryParams.append('newspaper_source', 'Newspaper');
      if (eGpSource) queryParams.append('e_GP_source', 'e-GP');
      if (onlineSource) queryParams.append('online_source', 'Online');
      if (advertisementSource) queryParams.append('advertisement_source', 'Advertisement');
      if (websiteSource) queryParams.append('website_source', 'Website');
      if (manualSource) queryParams.append('manual_source', 'Manual');







      console.log(queryParams)

      try {
        const response = await apiClient.get(
          `/user/tender-end-user/tender-view?${queryParams.toString()}`
        );
        const tenders = response.data.data;

        // Apply frontend filtering based on the status (if applicable)
        const filteredTenders = tenderStatus
          ? tenders.filter(tender => tender.tender_status === tenderStatus)
          : tenders;

        setTenderData(filteredTenders); // Set filtered data
        setFilteredData(filteredTenders); // Set filtered data
        setTotalItems(response.data.total); // Total count of items
      } catch (error) {
        console.error('Error fetching tenders:', error);
      }
    };

    fetchTenders();
  }, [
    keyword,
    tenderType,
    sourceType,
    tenderSection,
    district,
    currentPage,
    pageSize,
    selectedDateType, // Add selectedDateType to dependency array
    fromDate, // Add fromDate to dependency array
    toDate, // Add toDate to dependency array
    privateSection,
    govtSection,
    internationalSection,
    tender_call_typeSection,
    corrigendum_call_typeSection,
    cancellation_call_typeSection,
    ift,
    preq,
    enlistment,
    eoiFirm,
    eoiIndv,
    rfp,
    aucSal,
    goodsTenderOn,
    worksTenderOn,
    servicesTenderOn,
    newspaperSource,
    eGpSource,
    onlineSource,
    advertisementSource,
    websiteSource,
    manualSource,
    keyword,
    tenderType,
    sourceType,
    tenderSection,
    district,
    upazila,
    currentPage,
    pageSize,
    selectedDateType,
    fromDate,
    toDate,
    tenderStatus,
  ]);

  const handleStatusChange = (e) => {
    setTenderStatus(e.target.value);
    console.log("New Status:", e.target.value);
  };


  // Handle pagination change
  const handlePageChange = page => {
    setCurrentPage(page);
  };

  // Toggle wishlist functions
  const addToFavorites = async tenderId => {
    const tenderID = tenderId.id;
    setLoading(true);
    try {
      const response = await apiClient.post('/user/tender-end-user/favourite', {
        ten_id: tenderID,
      });
      setWishlist(prev => [...prev, tenderID]);

      const successMessage =
        response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Success!',
        text: successMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } catch (error) {
      console.error('Error adding to favorites:', error);
      const errorMessage =
        error.response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const removeFromFavorites = async tenderId => {
    const tenderID = tenderId.id;
    setLoading(true);
    try {
      const response = await apiClient.delete(
        `/user/tender-user/favourite/${tenderID}`
      );
      setWishlist(prev => prev.filter(id => id !== tenderID));
      const successMessage =
        response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Success!',
        text: successMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } catch (error) {
      console.error('Error removing from favorites:', error);
      const errorMessage =
        error.response?.data?.message || 'An unknown error occurred';

      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleWishlist = tender => {
    if (loading) return; // Prevent duplicate requests
    if (wishlist.includes(tender.id)) {
      removeFromFavorites(tender);
    } else {
      addToFavorites(tender);
    }
  };

  const handleViewDetailsClick = tenderId => {
    navigate(`/viewTenderDetails/${tenderId}`);
  };


  // Handle dropdown change and update the state
  const handleDateTypeChange = (value) => {
    setSelectedDateType(value);
    setFromDate(null); // Reset fromDate when the date type changes
    setToDate(null); // Reset toDate when the date type changes
  };

  // Handle checkbox change
  const handleCheckboxChange = (section) => {
    if (section === 'private') {
      setPrivateSection(!privateSection);
    } else if (section === 'govt') {
      setGovtSection(!govtSection);
    } else if (section === 'international') {
      setInternationalSection(!internationalSection);
    }
  };

  // Handle checkbox change
  const handleCheckboxChangeForTenderCallType = (section) => {
    if (section === 'tender_call_type') {
      setTender_call_typeSection(!tender_call_typeSection);
    } else if (section === 'corrigendum_call_type') {
      setCorrigendum_call_typeSection(!corrigendum_call_typeSection);
    } else if (section === 'cancellation_call_type') {
      setCancellation_call_typeSection(!cancellation_call_typeSection);
    }
  };

  const handleTenderPatternChange = (pattern) => {
    if (pattern === 'ift') {
      setIft(!ift);
    } else if (pattern === 'preq') {
      setPreq(!preq);
    } else if (pattern === 'enlistment') {
      setEnlistment(!enlistment);
    } else if (pattern === 'eoiFirm') {
      setEoiFirm(!eoiFirm);
    } else if (pattern === 'eoiIndv') {
      setEoiIndv(!eoiIndv);
    } else if (pattern === 'rfp') {
      setRfp(!rfp);
    } else if (pattern === 'aucSal') {
      setAucSal(!aucSal);
    }
  };

  const handleTenderTypeChange = (type) => {
    if (type === 'goods') {
      setGoodsTenderOn(!goodsTenderOn);
    } else if (type === 'works') {
      setWorksTenderOn(!worksTenderOn);
    } else if (type === 'services') {
      setServicesTenderOn(!servicesTenderOn);
    }
  };

  const handleSourceCheckboxChange = (source) => {
    if (source === 'newspaper') {
      setNewspaperSource(!newspaperSource);
    } else if (source === 'e_gp') {
      setEGpSource(!eGpSource);
    } else if (source === 'online') {
      setOnlineSource(!onlineSource);
    } else if (source === 'advertisement') {
      setAdvertisementSource(!advertisementSource);
    } else if (source === 'website') {
      setWebsiteSource(!websiteSource);
    } else if (source === 'manual') {
      setManualSource(!manualSource);
    }
  };



  return (
    <div className="p-6 mt-36  max-w-7xl container mx-auto">
      <h2 className="text-2xl font-bold mb-6">Tender Search</h2>
      <div>

        {/* Filter Controls */}
        <div className="bg-gray-100  rounded grid grid-cols-1 md:grid-cols-2 gap-6  my-1">
          {/* First Row */}
          <div className='flex items-center gap-1'>
            <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
              Keyword
            </label>
            <input
              type="text"
              placeholder="Search by keyword"
              value={keyword}
              onChange={e => setKeyword(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>


          <div className="bg-gray-100  rounded grid grid-cols-1 md:grid-cols-2 gap-6 ">
            {/* District and Upazila */}
            <div className='flex items-center gap-1'>
              <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
                District:
              </label>
              <input
                type="text"
                placeholder="Enter district"
                value={district}
                onChange={e => setDistrict(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>

            <div className='flex items-center gap-1'>
              <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
                Upazila:
              </label>
              <input
                type="text"
                placeholder="Enter upazila"
                value={upazila}
                onChange={e => setUpazila(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
          </div>

        </div>

        <div className='flex items-center gap-1 my-1'>
          <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
            Tender Pattern :
          </label>
          <div className="flex gap-4 flex-wrap">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="ift"
                checked={ift}
                onChange={() => handleTenderPatternChange('ift')}
                className="mr-2"
              />
              <label htmlFor="ift" className="text-gray-600 text-sm">IFT</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="preq"
                checked={preq}
                onChange={() => handleTenderPatternChange('preq')}
                className="mr-2"
              />
              <label htmlFor="preq" className="text-gray-600 text-sm">Preq</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="enlistment"
                checked={enlistment}
                onChange={() => handleTenderPatternChange('enlistment')}
                className="mr-2"
              />
              <label htmlFor="enlistment" className="text-gray-600 text-sm">Enlistment</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="eoiFirm"
                checked={eoiFirm}
                onChange={() => handleTenderPatternChange('eoiFirm')}
                className="mr-2"
              />
              <label htmlFor="eoiFirm" className="text-gray-600 text-sm">EOI(Firm)</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="eoiIndv"
                checked={eoiIndv}
                onChange={() => handleTenderPatternChange('eoiIndv')}
                className="mr-2"
              />
              <label htmlFor="eoiIndv" className="text-gray-600 text-sm">EOI(Indv)</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="rfp"
                checked={rfp}
                onChange={() => handleTenderPatternChange('rfp')}
                className="mr-2"
              />
              <label htmlFor="rfp" className="text-gray-600 text-sm">RFP</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="aucSal"
                checked={aucSal}
                onChange={() => handleTenderPatternChange('aucSal')}
                className="mr-2"
              />
              <label htmlFor="aucSal" className="text-gray-600 text-sm">Auc/Sal</label>
            </div>
          </div>
        </div>

        {/* Source Type */}
        <div className='flex items-center gap-1 my-1'>
          <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
            Source Type :
          </label>
          <div className="flex gap-4 flex-wrap">
            <div className="flex items-center">
              <input
                type="checkbox"
                id="newspaper"
                checked={newspaperSource}
                onChange={() => handleSourceCheckboxChange('newspaper')}
                className="mr-2"
              />
              <label htmlFor="newspaper" className="text-gray-600 text-sm">Newspaper</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="e_gp"
                checked={eGpSource}
                onChange={() => handleSourceCheckboxChange('e_gp')}
                className="mr-2"
              />
              <label htmlFor="e_gp" className="text-gray-600 text-sm">e-GP</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="online"
                checked={onlineSource}
                onChange={() => handleSourceCheckboxChange('online')}
                className="mr-2"
              />
              <label htmlFor="online" className="text-gray-600 text-sm">Online</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="advertisement"
                checked={advertisementSource}
                onChange={() => handleSourceCheckboxChange('advertisement')}
                className="mr-2"
              />
              <label htmlFor="advertisement" className="text-gray-600 text-sm">Advertisement</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="website"
                checked={websiteSource}
                onChange={() => handleSourceCheckboxChange('website')}
                className="mr-2"
              />
              <label htmlFor="website" className="text-gray-600 text-sm">Website</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="manual"
                checked={manualSource}
                onChange={() => handleSourceCheckboxChange('manual')}
                className="mr-2"
              />
              <label htmlFor="manual" className="text-gray-600 text-sm">Manual</label>
            </div>
          </div>
        </div>

        <div className="bg-gray-100  rounded grid grid-cols-1 md:grid-cols-2 gap-6 my-1">
          {/* Tender Pattern */}
          <div className='flex items-center w-full gap-1'>
            <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
              Tender Type :
            </label>
            <div className="flex gap-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="goods"
                  checked={goodsTenderOn}
                  onChange={() => handleTenderTypeChange('goods')}
                  className="mr-2"
                />
                <label htmlFor="goods" className="text-gray-600 text-sm">Goods</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="works"
                  checked={worksTenderOn}
                  onChange={() => handleTenderTypeChange('works')}
                  className="mr-2"
                />
                <label htmlFor="works" className="text-gray-600 text-sm">Works</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="services"
                  checked={servicesTenderOn}
                  onChange={() => handleTenderTypeChange('services')}
                  className="mr-2"
                />
                <label htmlFor="services" className="text-gray-600 text-sm">Services</label>
              </div>
            </div>
          </div>

          {/* Tender Section */}
          <div className='flex items-center gap-1'>
            <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
              Tender Section :
            </label>
            <div className="flex gap-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="private"
                  checked={privateSection}
                  onChange={() => handleCheckboxChange('private')}
                  className="mr-2"
                />
                <label htmlFor="private" className="text-gray-600 text-sm">Private</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="govt"
                  checked={govtSection}
                  onChange={() => handleCheckboxChange('govt')}
                  className="mr-2"
                />
                <label htmlFor="govt" className="text-gray-600 text-sm">Government</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="international"
                  checked={internationalSection}
                  onChange={() => handleCheckboxChange('international')}
                  className="mr-2"
                />
                <label htmlFor="international" className="text-gray-600 text-sm">International</label>
              </div>
            </div>
          </div>

        </div>

        <div className="bg-gray-100  rounded grid grid-cols-1 md:grid-cols-2 gap-6 my-1">
          <div className='flex items-center gap-1'>
            <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
              Tender Call Type :
            </label>
            <div className="flex gap-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="tender_call_type"
                  checked={tender_call_typeSection}
                  onChange={() => handleCheckboxChangeForTenderCallType('tender_call_type')}
                  className="mr-2"
                />
                <label htmlFor="tender_call_type" className="text-gray-600 text-sm">Tender</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="corrigendum_call_type"
                  checked={corrigendum_call_typeSection}
                  onChange={() => handleCheckboxChangeForTenderCallType('corrigendum_call_type')}
                  className="mr-2"
                />
                <label htmlFor="corrigendum_call_type" className="text-gray-600 text-sm">Corrigendum</label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="cancellation_call_type"
                  checked={cancellation_call_typeSection}
                  onChange={() => handleCheckboxChangeForTenderCallType('cancellation_call_type')}
                  className="mr-2"
                />
                <label htmlFor="cancellation_call_type" className="text-gray-600 text-sm">Cancellation</label>
              </div>
            </div>
          </div>


          {/* Tender Status */}
          {/* <div className='flex items-center gap-1'>
                <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
                  Tender Status:
                </label>
                <div className="flex items-center space-x-4">
                  <div>
                    <input
                      type="radio"
                      id="all"
                      name="tenderStatus"
                      value=""
                      checked={tenderStatus === ""}
                      onChange={e => setTenderStatus(e.target.value)}
                      className="mr-2"
                    />
                    <label htmlFor="all" className="text-gray-600 text-sm">All</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="live"
                      name="tenderStatus"
                      value="live"
                      checked={tenderStatus === "live"}
                      onChange={e => setTenderStatus(e.target.value)}
                      className="mr-2"
                    />
                    <label htmlFor="live" className="text-gray-600 text-sm">Live</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="expired"
                      name="tenderStatus"
                      value="expired"
                      checked={tenderStatus === "expired"}
                      onChange={e => setTenderStatus(e.target.value)}
                      className="mr-2"
                    />
                    <label htmlFor="expired" className="text-gray-600 text-sm">Expired</label>
                  </div>
                </div>
              </div> */}
          <div className='flex items-center gap-1'>
            <label className="block text-gray-600 text-sm mb-1 text-nowrap font-bold">
              Tender Status:
            </label>
            <div className="flex items-center space-x-4">
              {["", "live", "expired"].map((status, index) => (
                <div key={index}>
                  <input
                    type="radio"
                    id={status || "all"}
                    name="tenderStatus"
                    value={status}
                    checked={tenderStatus === status}
                    onChange={(e) => setTenderStatus(e.target.value)}
                    className="mr-2"
                  />
                  <label htmlFor={status || "all"} className="text-gray-600 text-sm">
                    {status === "" ? "All" : status.charAt(0).toUpperCase() + status.slice(1)}
                  </label>
                </div>
              ))}
            </div>
          </div>


        </div>


        <div className="flex items-center gap-4 my-1">
          <div className="flex items-center gap-1">
            <label className="block text-gray-600 text-sm  mb-1 text-nowrap font-bold">
              Select Date Type :
            </label>
            <select
              value={selectedDateType}
              onChange={(e) => handleDateTypeChange(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg"
            >
              <option value="">Select a Date Type</option>
              <option value="purchase_last">Purchase Last Date</option>
              <option value="prebid_meeting">Prebid Meeting Date</option>
              <option value="prebid_meeting_end">Prebid Meeting End Date</option>
              <option value="proposal_closing">Proposal Closing Date</option>
              <option value="opening">Opening Date</option>
            </select>
          </div>

          {/* Show date picker fields only if a date type is selected */}
          {selectedDateType && (
            <div className="flex items-center ml-4 gap-2">
              <label className="block text-gray-700  mb-1">
                {selectedDateType === 'purchase_last' && 'Purchase Last Date'}
                {selectedDateType === 'prebid_meeting' && 'Prebid Meeting Date'}
                {selectedDateType === 'prebid_meeting_end' && 'Prebid Meeting End Date'}
                {selectedDateType === 'proposal_closing' && 'Proposal Closing Date'}
                {selectedDateType === 'opening' && 'Opening Date'}
              </label>
              <div className="flex gap-2">
                <DatePicker
                  selected={fromDate}
                  onChange={(date) => setFromDate(date)}
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  placeholderText="From"
                />
                <DatePicker
                  selected={toDate}
                  onChange={(date) => setToDate(date)}
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  placeholderText="To"
                />
              </div>
            </div>
          )}

        </div>


      </div>



      {/* Display Tenders in Card Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 gap-4 md:mt-14 mt-6 py-4">
        {filteredData.length > 0 ? (
          filteredData.map(tender => (
            <div
              key={tender.id}
              className="bg-white border w-full shadow-md rounded-lg md:p-4 p-2 relative flex flex-col"
            >

              {/* <span className='text-blue-900'>Tender Title:</span> {tender.name} */}

              <h3 className="text-lg md:text-xl 2xl:text-2xl font-semibold text-gray-800 relative group">
                {/* Show first 40 words and add ellipsis */}
                <span className="line-clamp-2"><span className='text-blue-900'>Tender Title:</span> {tender.name}</span>


                {/* <span className="text-blue-500 cursor-pointer absolute bottom-0 left-0 right-0 text-xs mt-2 group-hover:block hidden">
                              See More
                            </span> */}

                {/* Hover to show full name */}
                <span className="absolute hidden group-hover:block bg-gray-600 text-white text-sm rounded-lg shadow-lg p-2 z-20 bottom-full mt-2  left-1/2 transform -translate-x-1/2 w-full mx-3">
                  {tender.name}
                </span>
              </h3>

              <div className="flex gap-4 bg-BrowsBg md:p-2 p-0.5 rounded-md w-full">
                <div className="mt-2 lg:ml-4 ml-2 mb-2">
                  <img
                    src={
                      tender.company_logo
                        ? `${PHOTO_BASE_URL_Admin}${tender.company_logo}`
                        : 'TenderLogo' // Placeholder image if no logo is available
                    }
                    alt={`${tender.name} Logo`}
                    className="lg:w-36 w-14 h-12 lg:h-28 md:mx-auto lg:mx-auto"
                  />
                </div>
                <div>
                  <TenderDescriptionDate
                    data={{
                      submission_date: tender.submission_date,
                      expired_after: tender.expired_after,
                      publishOn: tender.publish_on,
                      publish_on_before: tender.publish_on_before,
                      tender_status: tender.tender_status,
                    }}
                  />
                </div>
              </div>
              <div className="py-1.5 md:mt-2 mt-2">
                <div>
                  <TenderDescriptionID
                    data={{
                      tenderID: tender.tender_id,
                      invitation_for: tender.invitation_for,
                      type: tender.type,
                    }}
                  />
                </div>
              </div>

              <div className="mt-auto flex justify-between items-center">
                {/* View Details Button */}
                <button
                  onClick={e => {
                    e.stopPropagation();
                    handleViewDetailsClick(tender.id);
                  }}
                  className="border border-gray-300 text-blue-400 py-1 px-4 rounded-md hover:bg-gray-100"
                >
                  View Details
                </button>

                {/* Wishlist Icon */}
                <FaHeart
                  className={`cursor-pointer ${wishlist.includes(tender.id)
                      ? 'text-red-500 cursor-not-allowed pointer-events-none'
                      : 'text-black'
                    }`}
                  onClick={() => {
                    if (!wishlist.includes(tender.id)) {
                      toggleWishlist(tender);
                    }
                  }}
                />
              </div>

              {/* Total Views */}
              <div className="absolute md:top-4 top-2 md:right-4 right-2 flex items-center text-gray-500 bg-red-100 px-4 py-1 rounded-md">
                <FaEye className="mr-1" />
                <span>{tender.total_view || 0}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full text-center flex items-center justify-center w-full ">
            <img src={tenderNotFoundImage} alt="" className="object-contain " />
          </div>
        )}
      </div>

      {/* Pagination */}
      <div className="flex justify-center mt-4">
        <Pagination
          current={currentPage}
          total={totalItems}
          pageSize={pageSize}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default AdvanceSearch;




